<script setup>
  const props = defineProps({
    fillColor: {
      type: String,
      default: '#ffffff'
    }
  })
</script>

<template>
    <svg class="jwx-wind-gauge__marker jwx-wind-gauge__marker--nowcast" width="16" height="22" viewBox="0 0 16 22" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
        <path class="jwx-wind-gauge__marker-fill" :fill="props.fillColor" d="M11.11111.8 11.111 9.89 15 9.8909 8 20.8 1 9.8909 4.888 9.89 4.88889.8h6.22222Z"/>
        <path class="jwx-wind-gauge__marker-border" d="M11.56112.35V.8L11.56 9.44l3.4401.0009.8232.0002-.44456.69283-7 10.9091L8 21.63325l-.37874-.59024-7-10.90909L.1767 9.4411l.8232-.0002L4.438 9.44 4.43893.35h7.12219Zm-.90012.9H5.338v8.64004l-.00004.44985-.44985.00011H1.823L8 19.966l6.176-9.626h-3.0651l-.4499-.0001V1.25Z"/>
      </g>
    </svg>
</template>